// menu.interface.ts

export enum MenuType {
  HOME = 'HOME',
  ORGANIZADOR = 'ORGANIZADOR',
  EVENTOS = 'EVENTOS'
}

export interface MenuItem {
  label: string;
  icon: string;
  route?: string;
  action?: () => void;
  isSectionTitle?: boolean;
}

export interface MenuSection {
  title?: string;
  items: MenuItem[];
}

export interface AdditionalButton {
  label: string;
  icon?: string;
  action: () => void;
  classes?: string;
}

export interface MenuData {
  title: string;
  typeMenu: MenuType;
  showBackButton: boolean;
  showCreateButton: boolean;
  currentData: any;
  additionalButtons: AdditionalButton[];
  menuItems?: MenuItem[];
  menuSections?: MenuSection[];
}
